export default class Cliente {

  constructor(
    IdCliente = null,
    RazaoSocial = '',
    Fantasia,
    CpfCnpj,
    RgIe,
    OrgaoExpedidor,
    TipoPessoa = 'J',
    DataNascimento,
    Observacoes,
    DataCadastro,
    Contato,
    Status = 'A',
    InscricaoMunicipal,
    NumeroCliente
  ) {
    this.IdCliente = IdCliente;
    this.RazaoSocial = RazaoSocial;
    this.Fantasia = Fantasia;
    this.CpfCnpj = CpfCnpj;
    this.RgIe = RgIe;
    this.OrgaoExpedidor = OrgaoExpedidor;
    this.TipoPessoa = TipoPessoa;
    this.DataNascimento = DataNascimento;
    this.Observacoes = Observacoes;
    this.DataCadastro = DataCadastro;
    this.Contato = Contato;
    this.Status = Status;
    this.InscricaoMunicipal = InscricaoMunicipal;
    this.NumeroCliente = NumeroCliente;
  }
  
}